<template>
  <z-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <z-list
      class="list"
      v-model="loading"
      :finished="finished"
      finished-text=""
      :error.sync="error"
      @load="onLoad"
    >
      <z-cell
        v-for="item in list"
        :key="item"
        @click="HandleLego(item.title)"
        :title="item.title"
        :url="item.linkUrl"
        is-link
      />
    </z-list>
  </z-pull-refresh>
</template>

<script>
import native from '@zz-common/native-adapter'
import { PullRefresh, List, Cell } from '@zz-common/zz-ui'
// import DAL from '../../../dal'
import { lego } from '@zz-common/lego'
import { queryParams } from '../../../lib/utils'
import { getSecurityRule, getSecurityKnow } from '../../../api/resourceApi'

const query = queryParams()

export default {
  name: 'SafeCenterArticleList',
  data() {
    return {
      articleForm: query.articleForm || this.$route.query.articleForm || '', //1 平台规则 2 安全知识
      list: [],
      error: false,
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 1
    }
  },
  components: {
    zCell: Cell,
    zPullRefresh: PullRefresh,
    zList: List
  },
  methods: {
    HandleLego(title) {
      lego.send({
        pagetype: 'ZZUP_SAFECENTER_HOME',
        actiontype: 'ARTICLE_CLICK',
        backup: {
          form: this.articleForm,
          title
        }
      })
    },
    onLoad(isRefresh) {
      console.log('onLoad', isRefresh)
      if (isRefresh) {
        this.loading = true
        this.pageNum = 1
        this.list = []
      }
      this.getArticle()
      console.log('this.pageNum', this.pageNum)
      // if (this.pageNum !== 1) this.loading = false;// 加载状态结束
    },
    async getArticle() {
      const params = {
        pageSize: 20,
        pageNum: this.pageNum++
      }
      const fetchApi = +this.articleForm === 1 ? getSecurityRule : getSecurityKnow
      const res = await fetchApi(params)
      const { list = [] } = res
      this.loading = false
      // this.refreshing = false;
      console.log(res)
      if (list.length <= 0) {
        this.finished = true
        return
      }
      this.list.push(...list)
    },
    onRefresh() {
      this.finished = false
      this.refreshing = false
      this.onLoad(true)
    }
  },
  mounted() {
    console.log('articleForm', this.articleForm)
    native.setTitle({
      title: +this.articleForm === 1 ? '平台规则' : '安全知识'
    })
  },
  beforeRouteEnter(to, from, next) {
    console.log('ArticleList to', to)
    console.log('ArticleList from', from)
    next((_vm) => {
      native.wrap('resetRightAllButton')()
    })
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
